import React from "react";
import "./Publicgrievance.css";

const Publicgrievance = () => {
  return (
    <div class="heading-container">
      <h4>Public Grievence Officer</h4>

      <div class="content-container">
        <div class="rti-container">
          <div class="hindi-rti">
            <p>
              सभी प्रकार की जन शिकायतों को प्रस्तुत करने के लिए, कृपया लोक
              शिकायत अधिकारी, एनआईजीएसटी को लिखें। लोक शिकायत अधिकारी का विवरण
              निम्नानुसार दिया गया है:
            </p>

            <p> लोक शिकायत अधिकारी</p>
            <p>श्री. वरूना कुमार</p>
            <p> अपर माह सर्वेक्षक </p>
            <ul>
              <li> दूरभाषा सं : 040 – 27200188</li>
              <li> फैक्स सं : 040 – 27200286</li>
              <li> ई – मैल : nigst.hyd@surveyofindia.gov.in</li>
            </ul>
          </div>
          <div id="publicvertical-line"></div>
          <div class="english-rti">
            <p>
              For submitting all type of public grievances, please write to
              Public Grievance officer,NIGST. The details of Public Grievance
              officer given as under:
            </p>

            <p>PUBLIC GRIEVANCE OFFICER</p>
            <p>Addl. S.G. G.Varuna Kumar</p>
            <p>ADDL. SURVEYOR GENERAL</p>
            <ul>
              <li> TEL NO. 040 – 27200188</li>
              <li> FAX NO. 040 – 27200286</li>
              <li> E-MAIL : nigst.hyd@surveyofindia.gov.in</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Publicgrievance;
